export const LISTENING_SESSION_POLICY = {
  candidateLimit: 40,
  defaultCefrLevel: 'B1',
  levelWindowRadius: 1,
  recentClipLimit: 12,
  size: 8,
} as const;
